import { OutcropExamples } from '~/components/wiki/OutcropExamples';
import { useGroupDetailOutletContext } from '~/routes/wiki/regional/lithostrat/group.$groupId';

export default function LithostratGroupAnaloguesRoute() {
  const { group } = useGroupDetailOutletContext();
  return <OutcropExamples parentType="group" parent={group} />;
}
